import styled from "styled-components";

export const Form = styled.form`
  position: relative;
  width: 100%;
  height: 50px;
  border-top: 1px solid #EAEAEA;
  border-bottom: 1px solid #EAEAEA;
`;

export const Input = styled.input`
  width: 100%;
  height: 100%;
  padding: 10px 60px 10px 20px;
  border: none;
  box-sizing: border-box;
  font-family: "Reader";
  font-size: 18px;

  &:focus {
    outline: 1px solid var(--color-secondary);
  }

  &::placeholder {
    color: #b9b9b9;
  }
`;

export const CancelButton = styled.button`
  position: absolute;
  top: 50%;
  right: 45px;
  transform: translateY(-50%);
  background: none;
  border: none;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  fill: var(--color-med-gray);
  cursor: pointer;

  &:hover,
  &:focus {
    fill: var(--color-secondary);
    outline: none;
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -2px;
    height: 20px;
    border-right: 1px solid var(--color-light-gray);
  }
`;

export const CancelIcon = styled.svg`
  width: 14px;
  height: 14px;
`;

export const Icon = styled.img`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  margin: 0 20px 0 20px;
`;
